import { useCallback, useState } from "react";
import { acceptUnattendedAccessTerms, getUnattendedAccessTerms } from "../api/apiClient";

export const useUnattendedAccessTerms = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [terms, setTerms] = useState(null);
    const [loading, setLoading] = useState(false);
    const [accepting, setAccepting] = useState(false);
    const [error, setError] = useState(null);
    const [pendingAction, setPendingAction] = useState(null);

    const fetchTerms = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const data = await getUnattendedAccessTerms();
            setTerms(data);
        } catch (fetchError) {
            console.error("Failed to fetch unattended access terms:", fetchError);
            setError("Die Nutzungsbedingungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.");
        } finally {
            setLoading(false);
        }
    }, []);

    const promptForTerms = useCallback((retryAction) => {
        setPendingAction(() => retryAction);
        setTerms(null);
        setError(null);
        setIsOpen(true);
        fetchTerms();
    }, [fetchTerms]);

    const closeModal = () => {
        setIsOpen(false);
        setPendingAction(null);
        setTerms(null);
        setError(null);
    };

    const acceptTerms = async () => {
        if (!terms) {
            return;
        }

        setAccepting(true);
        setError(null);

        try {
            await acceptUnattendedAccessTerms(terms.version);

            setIsOpen(false);
            const retryAction = pendingAction;
            setPendingAction(null);
            setTerms(null);

            if (retryAction) {
                retryAction();
            }
        } catch (acceptError) {
            let errorData;
            try {
                errorData = JSON.parse(acceptError.message);
            } catch (parseError) {
                errorData = null;
            }

            if (errorData?.status === 400 && errorData?.code === 1200) {
                await fetchTerms();
            } else {
                console.error("Failed to accept unattended access terms:", acceptError);
                setError("Die Bestätigung ist fehlgeschlagen. Bitte versuchen Sie es erneut.");
            }
        } finally {
            setAccepting(false);
        }
    };

    return { isOpen, terms, loading, accepting, error, promptForTerms, closeModal, acceptTerms };
};
